enum PersonType {
  NATURAL_PERSON = 'NATURAL_PERSON',
  MORAL_PERSON = 'MORAL_PERSON',
}

export default PersonType;
